// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as UseSafeTimeout from "../../../../node_modules/@makerinc/use-safe-timeout/lib/es6_global/src/UseSafeTimeout.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as Unicons$Showside from "../icons/Unicons.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as ImageSize$Showside from "../utils/ImageSize.bs.js";
import * as Cloudinary$Showside from "../utils/Cloudinary.bs.js";
import * as IconButton$Showside from "./IconButton.bs.js";
import * as ScrollLock$Showside from "../utils/ScrollLock.bs.js";
import * as Scrollable$Showside from "./Scrollable.bs.js";
import * as IframeEmbed$Showside from "../utils/IframeEmbed.bs.js";
import * as Prioritize2$Showside from "../utils/Prioritize2.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as SmartNavVideo$Showside from "./SmartNavVideo.bs.js";
import * as UseWindowSize$Showside from "../hook/UseWindowSize.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as PhotoSliderThumbnails$Showside from "./PhotoSliderThumbnails.bs.js";
function DesktopPhotoZoom$SliderItem(Props) {
  var renderChildren = Props.renderChildren;
  var image = Props.image;
  var width = Props.width;
  var height = Props.height;
  var onSize = Props.onSize;
  var onClick = Props.onClick;
  var maxSizeOpt = Props.maxSize;
  var maxSize = maxSizeOpt !== undefined ? maxSizeOpt : true;
  var windowWidth = UseWindowSize$Showside.useWindowWidth(undefined, undefined, undefined, undefined);
  var src = Cloudinary$Showside.makeUrl(Belt_Option.getWithDefault(image, ""), windowWidth, undefined, /* Limit */0, undefined);
  var match = ImageSize$Showside.useImageSize(src);
  var match$1 = image !== undefined ? [match[0], match[1]] : [undefined, undefined];
  var match$2 = width > 0 && height > 0 ? [width, height] : [match$1[0], match$1[1]];
  var imageHeight = match$2[1];
  var imageWidth = match$2[0];
  var maxHeight;
  if (imageWidth !== undefined && imageHeight !== undefined && imageWidth > 0 && imageHeight > 0) {
    var maxHeight$1 = windowWidth / (imageWidth / imageHeight);
    maxHeight = maxSize ? Math.min(maxHeight$1, imageHeight) : maxHeight$1;
  } else {
    maxHeight = undefined;
  }
  React.useEffect(function () {
    if (maxHeight !== undefined && maxHeight > 0) {
      Curry._1(onSize, maxHeight);
    }
  }, [maxHeight]);
  var tmp = {
    className: CSS$Showside.prefix(Cn.make([maxHeight !== undefined ? "" : "invisible", "flex items-center justify-center h-full w-full overflow-hidden relative transition-opacity duration-300 cursor-zoom-out"]))
  };
  var tmp$1 = Belt_Option.map(maxHeight, function (maxHeight) {
    return {
      height: String(maxHeight) + "px"
    };
  });
  if (tmp$1 !== undefined) {
    tmp.style = Caml_option.valFromOption(tmp$1);
  }
  return React.createElement("div", tmp, React.createElement(ScrollLock$Showside.make, {
    children: React.createElement(Prioritize2$Showside.make, {
      render: function (priority) {
        return React.createElement(DataAttribute$Showside.make, {
          dataTestId: "pdp-photo",
          children: React.createElement("div", {
            className: CSS$Showside.prefix(Cn.make(["absolute inset-0"])),
            onClick: function (param) {
              Curry._1(onClick, undefined);
            }
          }, Curry._1(renderChildren, priority))
        });
      }
    })
  }));
}
DesktopPhotoZoom$SliderItem.displayName = "DesktopPhotoZoom.SliderItem";
var SliderItem = {
  make: DesktopPhotoZoom$SliderItem
};
function DesktopPhotoZoom(Props) {
  var product = Props.product;
  var variantId = Props.variantId;
  var medias = Props.medias;
  var viewport = Props.viewport;
  var onSlideChange = Props.onSlideChange;
  var onClickThumbnail = Props.onClickThumbnail;
  var thumbnailsPositionOpt = Props.thumbnailsPosition;
  var selectedIndex = Props.selectedIndex;
  var onClose = Props.onClose;
  var onPhotoZoomed = Props.onPhotoZoomed;
  var thumbnailsPosition = thumbnailsPositionOpt !== undefined ? thumbnailsPositionOpt : "bottom";
  var match = ConfigurationProvider$Showside.use(undefined).config;
  var settings = match.settings;
  var match$1 = ViewportContext$Showside.use(undefined);
  var windowSize = match$1.windowSize;
  var match$2 = React.useState(function () {
    return 0;
  });
  var setCurrentSlide = match$2[1];
  var currentSlide = match$2[0];
  var match$3 = React.useState(function () {
    return Belt_Option.getWithDefault(selectedIndex, -1);
  });
  var setSlideToIndex = match$3[1];
  var slideToIndex = match$3[0];
  var match$4 = React.useState(function () {
    return 0;
  });
  var setSlidesRendered = match$4[1];
  var slidesRendered = match$4[0];
  React.useEffect(function () {
    Curry._1(setSlideToIndex, function (param) {
      return Belt_Option.getWithDefault(selectedIndex, -1);
    });
  }, [selectedIndex]);
  var scrollTo = React.useRef(function (param) {});
  var scrollableElement = React.useRef(null);
  var getSlides = function (param) {
    return Belt_Option.mapWithDefault(Belt_Option.map(Caml_option.nullable_to_opt(scrollableElement.current), function (prim) {
      return prim.children;
    }), [], function (prim) {
      return Array.prototype.slice.call(prim);
    });
  };
  UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var scrollToIndex = function (index, slidesRendered) {
    var element = Belt_Array.get(getSlides(undefined), slideToIndex);
    var match = slidesRendered === medias.length;
    if (element !== undefined && match) {
      Curry._1(onPhotoZoomed, slideToIndex);
      return Curry._1(scrollTo.current, {
        TAG: /* Element */0,
        _0: Caml_option.valFromOption(element)
      });
    }
  };
  React.useEffect(function () {
    if (slideToIndex >= 0) {
      scrollToIndex(slideToIndex, slidesRendered);
    }
  }, [slideToIndex, slidesRendered]);
  var handleScroll = function (param, param$1) {
    var activeIndex = Belt_Array.reduceWithIndex(Belt_Array.map(Belt_Array.map(getSlides(undefined), function (prim) {
      return prim.getBoundingClientRect();
    }), function (prim) {
      return prim.top;
    }), undefined, function (acc, curr, index) {
      if (curr <= 0) {
        return index;
      } else {
        return acc;
      }
    });
    Curry._1(setCurrentSlide, function (param) {
      return activeIndex;
    });
    Curry._1(setSlideToIndex, function (param) {
      return -1;
    });
    Curry._1(onSlideChange, {
      activeIndex: activeIndex
    });
  };
  var items = Belt_Array.mapWithIndex(medias, function (idx, item) {
    var active = Caml_obj.equal(idx, currentSlide);
    switch (item.TAG | 0) {
      case /* Image */0:
        var match = item._0;
        var url = match.url;
        return React.createElement(DesktopPhotoZoom$SliderItem, {
          idx: idx,
          viewport: viewport,
          active: active,
          renderChildren: function (priority) {
            return React.createElement(SmartImg$Showside.make, {
              src: url,
              fit: /* ScaleDown */0,
              priority: active ? 0 : priority
            });
          },
          image: url,
          width: match.width,
          height: match.height,
          onSize: function (param) {
            return Curry._1(setSlidesRendered, function (value) {
              return value + 1 | 0;
            });
          },
          onClick: function (param) {
            Curry._1(onClose, undefined);
          },
          key: variantId
        });
      case /* Video */1:
        var video = item._0;
        var match$1 = Product$Showside.getVideoSource(video);
        if (match$1 === undefined) {
          return null;
        }
        var height = match$1.height;
        var width = match$1.width;
        var url$1 = match$1.url;
        var tmp = {
          idx: idx,
          viewport: viewport,
          active: active,
          renderChildren: function (param) {
            var tmp = {
              src: url$1,
              viewport: viewport,
              objectFit: width !== 0 || height !== 0 ? "contain" : "cover",
              prioritize: true,
              autoplay: settings.videoAutoPlay,
              loop: settings.videoLoop,
              muted: settings.videoMute,
              controls: settings.videoControls,
              key: variantId
            };
            if (video.posterUrl !== undefined) {
              tmp.poster = video.posterUrl;
            }
            return React.createElement(SmartNavVideo$Showside.make, tmp);
          },
          width: width,
          height: height,
          onSize: function (param) {
            return Curry._1(setSlidesRendered, function (value) {
              return value + 1 | 0;
            });
          },
          onClick: function (param) {
            Curry._1(onClose, undefined);
          },
          maxSize: false,
          key: variantId
        };
        if (video.posterUrl !== undefined) {
          tmp.image = Caml_option.valFromOption(video.posterUrl);
        }
        return React.createElement(DesktopPhotoZoom$SliderItem, tmp);
      case /* IframeEmbed */2:
        var url$2 = item._0.url;
        return React.createElement(DesktopPhotoZoom$SliderItem, {
          idx: idx,
          viewport: viewport,
          active: active,
          renderChildren: function (param) {
            return React.createElement(IframeEmbed$Showside.make, {
              url: url$2
            });
          },
          width: windowSize.width,
          height: windowSize.height,
          onSize: function (param) {
            return Curry._1(setSlidesRendered, function (value) {
              return value + 1 | 0;
            });
          },
          onClick: function (param) {
            Curry._1(onClose, undefined);
          },
          maxSize: false,
          key: variantId
        });
    }
  });
  var tmp = {
    medias: medias,
    setSlideToIndex: setSlideToIndex,
    onClickThumbnail: onClickThumbnail,
    visibility: "hover",
    product: product,
    variantId: variantId
  };
  if (currentSlide !== undefined) {
    tmp.currentSlide = Caml_option.valFromOption(currentSlide);
  }
  return React.createElement("div", {
    className: CSS$Showside.prefix("fixed inset-0 bg-white z-40")
  }, React.createElement("div", {
    className: CSS$Showside.prefix("absolute inset-0 overflow-hidden group"),
    style: {
      backgroundColor: settings.pdpGalleryBGColor
    }
  }, React.createElement(Scrollable$Showside.make, {
    restorationId: "pdp-photo-slider",
    scrollToRef: scrollTo,
    onScroll: handleScroll,
    children: items,
    fwdRef: scrollableElement,
    className: CSS$Showside.prefix("absolute inset-0 space-y-4"),
    rememberScrollPosition: false
  }), React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["absolute", thumbnailsPosition === "center" ? "top-1/2 left-0 pl-8 transform -translate-y-1/2" : "bottom-0 right-0 pb-8 pr-8"]))
  }, React.createElement(PhotoSliderThumbnails$Showside.make, tmp))), React.createElement("div", {
    className: CSS$Showside.prefix("absolute top-6 right-5")
  }, React.createElement(IconButton$Showside.make, {
    onClick: function (param) {
      Curry._1(onClose, undefined);
    },
    shadow: true,
    icon: React.createElement(Unicons$Showside.UilTimes.make, {
      size: /* Px */{
        _0: 28
      }
    }),
    title: "Close",
    dataTestId: "pdp-button-open-close",
    className: CSS$Showside.prefix("pointer-events-auto")
  })));
}
DesktopPhotoZoom.displayName = "DesktopPhotoZoom";
var make = DesktopPhotoZoom;
export { SliderItem, make };
/* react Not a pure module */